module.exports = __webpack_public_path__ + "img/BOXES.57326635.png";